import * as React from 'react';
import { createElement } from 'react';
import { Button } from '@alifd/next';
import './index.scss';
export default class Buttons extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
    }
    getData = (val) => {
        console.log(val, 'valvalval');
    };
    componentWillReceiveProps(nextProps) {
        console.log(nextProps, 'nextProps');
    }
    linkRouter(href) {
        if (href) {
            window.open(href, '_blank');
        }
    }
    render() {
        const sizeClassName = {
            small: "btn-small",
            medium: "btn-medium",
            large: "btn-large",
        }[this.props.size] || "";
        const typeClassName = {
            success: "btn-success",
            danger: "btn-danger",
            warning: "btn-warning",
            dark: "btn-dark",
        }[this.props.type] || "";
        const className = `btn-common ${sizeClassName} ${typeClassName}`;
        return (createElement("span", null,
            this.props.type !== 'success' && this.props.type !== 'danger' && this.props.type !== 'warning' && this.props.type !== 'dark' &&
                createElement(Button, { type: this.props.type, size: this.props.size, onClick: () => this.linkRouter(), style: this.props.style }, this.props.btnContent),
            (this.props.type === 'success' || this.props.type === 'danger' || this.props.type === 'warning' || this.props.type === 'dark') &&
                createElement("button", { style: this.props.style, className: className, onClick: () => this.getData(this.props.listRouter) }, this.props.btnContent)));
    }
}
;
